import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 15.6V12m0-3.6v.09M21.6 12c0 1.38-.292 2.692-.816 3.878l.817 5.721-4.903-1.226a9.56 9.56 0 0 1-4.699 1.227 9.6 9.6 0 1 1 9.6-9.6"
    />
  </svg>
);
export default SvgMessageAlertCircle;
